export const sidebarMenuItems = [
	{
		title: 'Algemene instellingen',
		url: '/app/settings',
		name: 'general',
	},
	{
		title: 'Campagnes',
		url: '/app/settings/campaigns',
		name: 'campaigns',
	},
	{
		title: 'Promoties',
		url: '/app/settings/promotions',
		name: 'promotions',
	},
	{
		title: 'Gebruikers',
		url: '/app/settings/users',
		name: 'users',
	},
	{
		title: 'Synchronisatie',
		url: '/app/settings/sync',
		name: 'sync',
	},
	{
		title: 'Persoonlijke instellingen',
		url: '/app/settings/user',
		name: 'user',
	},
	{
		title: 'Kantlijn widgets',
		url: '/app/settings/sidebar-widgets',
		name: 'sidebar-widgets',
	},
];


// WEBPACK FOOTER //
// ./src/config/settingsMenu.js